<div class="bg-th-blue mt-0 container-fluid">
    <div class=" d-flex justify-content-between align-content-center h-35">
        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>



    </div>
</div>
<div id="test" class="fixed-map3">
    <div class="position-absolute" id="map_tooltip" data-bs-html="true">
    </div>
</div>